import * as THREE from "three";
import Experience from "../Experience.js";

export default class SamirBasicTurn {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    // same thing as above but with samirModel
    this.resource = this.resources.items.samirBasicTurn2;
    // resource appears to be Object3D-like, need to test.
    console.log(this.resource);
    this.scene.add(this.resource);
    this.resource.scale.set(0.01, 0.01, 0.01);
    this.resource.rotation.x -= Math.PI / 2;
    //
    // this.model = this.resource.scene;
    // this.model.scale.set(-0.85, 0.85, -0.85);
    // console.log(this.model);
    // recursively serach this.model, children are in this.model.children array. Log the child if any have an animations array with length 1
    // this.model.traverse((child) => {
    //   if (child.animations && child.animations.length === 1) {
    //     console.log(child);
    //   }
    // });
    this.mixer = new THREE.AnimationMixer(this.resource);
    this.action = this.mixer.clipAction(this.resource.animations[0]);
    // this.scene.add(this.model);
    this.action.play();
  }
  tick() {
    if (this.mixer) {
      this.mixer.update(this.experience.clock.getDelta() * 1);
    }
  }
}
